import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { globalFileIcon } from "../../../axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import { setToggleMenu, setToggleCart } from "../../server/CartsOpen";
import Navigator from "./NAVIGATOR";
import HeaderConnection from "./HeaderConnection";
import HeaderFilterAndSort from "./HeaderFilterAndSort";
import HeaderCart from "./HeaderCart";
import { ShoppingCart } from "lucide-react";
import ProductFilters from "../routs/categoryPage/ProductFilters";
import MiniCart from "../../components/miniCart/MiniCart";
import { setFilterSort } from "../../server/Product";

const Header = ({
  setAllProduct,
  setAdminToCustomer,
  currentSubCategory,
  setProductPopUp,
  setSelectedProd,
}) => {
  const dispatch = useDispatch();
  const {
    user,
    role,
    stationId,
    productsInCart,
    toggleMenu,
    deliveryPrice,
    filterAndSort,
  } = useSelector((state) => ({
    user: state.user.user,
    role: state.user.role,
    stationId: state.user.stationId,
    productsInCart: state.productsInCart.productsInCart,
    toggleMenu: state.openCart.toggleMenu,
    deliveryPrice: state.productsInCart.deliveryPrice,
    filterAndSort: state.displayProduct.filterAndSort,
  }));
  const { pathname } = useLocation();
  const [cartIsOpen, setCartIsOpen] = useState(false);

  useEffect(() => {
    if (!role && user) {
      dispatch(setToggleCart(true));
    }
  }, [role, user, dispatch]);

  const setCart = (setOpen) => {
    if (filterAndSort) {
      dispatch(setFilterSort(false));
      dispatch(setToggleCart(true));
      setCartIsOpen(true);
    } else {
      dispatch(setToggleCart(setOpen));
      setCartIsOpen(setOpen);
    }
  };

  return (
    <header>
      <div className="header-wrapper">
        <HeaderConnection
          setAllProduct={setAllProduct}
          setAdminToCustomer={setAdminToCustomer}
          user={user}
          role={role}
          stationId={stationId}
          basicHeader={false}
        />
        {pathname !== "/about" ? (
          <>
            <div className="head-left-side">
              <div className="menu" onClick={() => dispatch(setToggleMenu())}>
                {toggleMenu ? (
                  <img src={globalFileIcon + "close-menu.svg"} alt="close" />
                ) : (
                  <img src={globalFileIcon + "menu-new.svg"} alt="menu" />
                )}
              </div>
              <Navigator currentSubCategory={currentSubCategory} />
            </div>
          </>
        ) : null}
      </div>

      <div className="header-second-row">
        <HeaderCart
          role={role}
          user={user}
          pathname={pathname}
          productsInCart={productsInCart}
          deliveryPrice={deliveryPrice}
        />
        <div className="action-buttons-row">
          {!role && (
            <div className="shoping-cart" onClick={() => setCart(!cartIsOpen)}>
              <ShoppingCart />
              <span>לעגלת הקניות</span>
            </div>
          )}

          {pathname.includes("/category/") && (
            <>
              {!role && <div className="cross-line">|</div>}
              <HeaderFilterAndSort />
            </>
          )}
        </div>

        {(cartIsOpen ||
          pathname.includes("/category/") ||
          pathname.includes("/search")) && (
          <div className="side">
            {filterAndSort &&
              (pathname.includes("/category/") ||
                pathname.includes("/search")) && <ProductFilters />}
            {cartIsOpen && (
              <MiniCart
                setProductPopUp={setProductPopUp}
                setSelectedProd={setSelectedProd}
              />
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
